<template>
  <b-container class="container-fluid d-flex h-100 flex-column" style="margin-top:90px;">
    <br/>
    <b-row>
      <b-col cols="6">
        <h3>Welcome Back, {{name}}!</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Lectus vestibulum mattis ullamcorper velit sed ullamcorper morbi.
          Faucibus purus in massa tempor nec feugiat nisl pretium fusce.
          Senectus et netus et malesuada fames ac turpis.</p>
        <b-button style="background-color: #660032;" >My Account</b-button>
      </b-col>
      <b-col cols="6" >
        <b-row>
          <b-col>
            <h3>My Trends - August 2022</h3>    
          </b-col>
        </b-row>
        <b-row>
          <b-col  style="background-color: lightgrey;border-radius: 10px">
            <br/>
            <line-chart></line-chart>
            <br/>
          </b-col> 
        </b-row>
      </b-col>
    </b-row>
    <br/>
    <b-row>
      <b-col style="background-color: lightgrey;border-radius: 10px">
        <br/>
        <div>
          <b-row class="mx-auto">
            <b-col cols="1">
              <font-awesome-icon icon="fa-solid fa-circle-check" style="color:#ffcc00"/>
            </b-col>
            <b-col cols="auto">
              <h5>My Account</h5>
            </b-col>
          </b-row>
          
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
            
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>
            </b-col>
          </b-row>
          <br/>
        </div>
      </b-col>
      &nbsp;&nbsp;
      <b-col style="background-color: lightgrey;border-radius: 10px" >
        <br/>
        <b-row class="mx-auto">
          <b-col cols="1">
            <font-awesome-icon icon="fa-solid fa-circle-check"  style="color: #660032"/>
          </b-col>
          <b-col cols="auto">
            <h5>My Schools</h5>
          </b-col>
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <p> - Lorem ipsum dolor sit amet</p>  
          </b-col>
        </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>  
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>  
            </b-col>
          </b-row>
        <br/>
      </b-col>
      &nbsp;&nbsp;
      <b-col style="background-color: lightgrey;border-radius: 10px" >
        <br/>
        <div>
          <b-row class="mx-auto">
            <b-col cols="1">
              <font-awesome-icon icon="fa-solid fa-circle-check" style="color:#ffcc00;" />
            </b-col>
            <b-col cols="auto">
              <h5>My Teachers</h5>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>
            </b-col>
          </b-row>
          <br/>
        </div>
      </b-col>
      &nbsp;&nbsp;
      <b-col style="background-color: lightgrey;border-radius: 10px" class="mx-auto">
        <br/>
        <b-row class="mx-auto">
            <b-col cols="1">
              <font-awesome-icon icon="fa-solid fa-circle-check" style="color:#ffcc00"/>
            </b-col>
            <b-col cols="auto">
              <h5>My Teachers</h5>
            </b-col>
        </b-row>
        <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>
            </b-col>
          </b-row>
        <br/>
      </b-col>
    </b-row>
  
  </b-container>
</template>

<script>
import LineChart from  '@/components/landing/LineChart'

export default {
  name: "admin",
  components:{
    LineChart
  },
  props: [ "token"],
    data: function() {
    return{
      isLoading: false,
      data:[],
      name:''
    }
  },
  mounted() {
    this.name = localStorage.Name;
  },
  methods: {
    dataSuccessLoad: function (res) {
      this.data = res;
      this.loading = false;
    },
    dataError: function (status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>